<template>
    <div id="app" class="wrapper">
        <router-view></router-view>
    </div>
</template>

<script>
import Socket from 'src/websocket'
import commonApi from 'src/api/common'
import { mapActions, mapGetters } from 'vuex'
// import getParams from 'src/utils/getParamsFromLocation'
import xesCookie from 'src/utils/utils'
import eventBusMap from 'src/config/eventBusMap'
export default {
    name: 'App',
    data() {
        return {
            commonApi,
            socket: null
        }
    },
    computed: mapGetters(['adminId']),
    mounted() {
        // 第一次进入
        if (this.$route.meta.first) {
            const jumpUrl = this.$route.query.domain
            this.$axios.get(commonApi.getUserInfo).then(response => {
                const adminId = response.adminId
                // 判断是否有年级、学科，若其中一个没有，则提示，并跳转至admin
                if (!response.grade_ids || !response.subject_id) {
                    xesCookie.delCookie('token')
                    this.$alert('请设置年级、学科信息', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                             const url = xesCookie.getUrlParams('domain')
                            window.location.href = url || 'https://tnt.saasz.vdyoo.com/'
                        }
                    })
                    return
                }
                if (!response.school_id || response.school_id == '0') {
                    xesCookie.delCookie('token')
                    this.$alert('请联系教研门户管理员设置学校', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            const url = xesCookie.getUrlParams('domain')
                            window.location.href = url || 'https://tnt.saasz.vdyoo.com/'
                        }
                    })
                    return
                }
                if (adminId) {
                    // 将用户信息存储至localstorage
                    localStorage.setItem(
                        'user_info',
                        JSON.stringify({
                            token,
                            adminId,
                            userName: response.realname,
                            subjectName: response.subject_name,
                            subjectId: response.subject_id,
                            noticeSign: response.noticeSign
                        })
                    )
                    // 将用户信息存储至vuex
                    this.getUserInfo()
                    // 链接websocket
                    // this.linkSocket()
                    // 发布初始化完成事件
                    window.eventBus.$emit(eventBusMap.initProject)
                }
            })
        } else {
            // 将用户信息存储至vuex
            this.getUserInfo()
            // 发布初始化完成事件
            window.eventBus.$emit(eventBusMap.initProject)

            // 链接websocket
            // if (!window.coursewareSocket) {
            //     this.linkSocket()
            // }
        }
        const w = document.documentElement.clientWidth
        const h = document.documentElement.clientHeight
        this.setScreenPixel({ w, h })
        // 监听window resize
        window.addEventListener('resize', e => {
            // 获取当前屏幕宽高并存储至vuex
            const w = document.documentElement.clientWidth
            const h = document.documentElement.clientHeight
            this.setScreenPixel({ w, h })
        })
        // 加载时设置屏幕宽高
        this.$nextTick(() => {
            const w = document.documentElement.clientWidth
            const h = document.documentElement.clientHeight
            this.setScreenPixel({ w, h })
        })
        // 在body阻止拖拽的默认事件
        document.body.addEventListener('drop', ev => {
            ev.preventDefault()
            ev.stopPropagation()
        })
        document.body.addEventListener('drag', ev => {
            ev.preventDefault()
            ev.stopPropagation()
        })
        // document.body.addEventListener('dragstart', (ev) => {
        //   ev.dataTransfer = ev.originalEvent.dataTransfer
        //   const domId = ev.target.id
        //
        //   ev.dataTransfer.setData('domId', domId)
        //   ev.preventDefault()
        //   ev.stopPropagation()
        // })
    },
    methods: {
        ...mapActions(['getUserInfo', 'setScreenPixel']),
        // socket message监听
        onmessage(data) {
            console.log(data, '====socket instance message=====')
            // 收到socket推送，弹出提示信息，并emit相关事件
            if (data && data.type == 'courseware' && data.msg) {
                this.$message({
                    message: data.msg,
                    type: 'success',
                    duration: 5000
                })
                // emit相关eventBus事件
                window.eventBus.$emit(eventBusMap.newPageCreated, data)
            }

            // 课件质检
            if (data && data.type == 'quality_test' && data.msg) {
                this.$message({
                    message: data.msg,
                    type: 'success',
                    duration: 5000
                })
                window.eventBus.$emit(
                    eventBusMap.coursewareTestOver,
                    data.coursewareId
                )
            }

            // 课件质检 错误
            if (data && data.type == 'quality_test_error' && data.msg) {
                this.$message({
                    message: data.msg,
                    type: 'error',
                    duration: 5000
                })
                window.eventBus.$emit(
                    eventBusMap.coursewareTestError,
                    data.coursewareId
                )
            }
        },
        // 链接websocket
        linkSocket() {
            // 测试环境端口:10.99.1.29:9003先手动设置
            // 线上环境host：cwnotice.xesv5.com
            console.log(process.env, '====my_env======')

            // 获取env根据不同的env参数，配置socket连接不同的host
            const myEnv = process.env.MY_ENV
            // let host = 'cwnotice.xesv5.com'
            // let host = '10.99.1.29:9003'
            let host
            if (myEnv === 'prod') {
                // 线上环境
                host = 'cwnotice.xesv5.com'
            } else {
                // 其他情况，连接测试环境，默认测试环境
                host = '10.90.71.47:8088'
            }
            let adminId =
                process.env.NODE_ENV === 'development' ? 0 : this.adminId
            this.socket = new Socket({
                host: `ws://${host}`,
                adminId,
                onmessageListener: this.onmessage
            })
            window.coursewareSocket = this.socket
            this.socket.login()
        }
    }
}
</script>
<style lang="scss">
@import 'sass/main';
body{font-family: Microsoft YaHei;}
</style>



// WEBPACK FOOTER //
// App.vue?ac363838